import { useCallback, useState } from "react";
import { toast } from "react-toastify";
import { commonToast } from "../../../Utils";
import { saveSmsAlerts } from "../../../services/mfa/mfaSettingsApi";

export const INVALID_MOBILE = "Enter a 10-digit US mobile number.";
export const SAVED_MESSAGE = "Mobile saved. We'll text you about security changes.";
export const SAVE_FAILED_MESSAGE = "We couldn't save your number. You can add it later in My Profile.";

// US only, as My Profile's phone field (country "us", onlyCountries ["us"]): 10 digits, or 11 with a leading 1.
const isUsMobile = (value) => {
  const digits = String(value || "").replace(/\D/g, "");
  return digits.length === 10 || (digits.length === 11 && digits.startsWith("1"));
};

// docs/specs/authenticator-mfa-sms-enroll.md §3: Skip, Save and a failed save all end in onDone — the step never
// blocks the user. `token`: the login path's not-yet-stored session token; the settings path leaves it out.
const useAddMobileStep = ({ token, onDone }) => {
  const [mobile, setMobile] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const [agreed, setAgreed] = useState(false); // the consent says "By selecting this check box"

  const skip = useCallback(() => {
    if (!busy) onDone();
  }, [busy, onDone]);

  const save = useCallback(async () => {
    if (busy || !agreed) return;
    if (!isUsMobile(mobile)) {
      setError(INVALID_MOBILE);
      return;
    }
    setError(null);
    setBusy(true);
    try {
      await saveSmsAlerts({ mobile, token });
      toast.success(SAVED_MESSAGE, { ...commonToast });
    } catch (e) {
      // Never log the number; the status is enough to find it in node's log.
      console.error("saveSmsAlerts failed:", e?.response?.status ?? e?.message);
      toast.error(SAVE_FAILED_MESSAGE, { ...commonToast });
    } finally {
      setBusy(false);
    }
    onDone();
  }, [busy, agreed, mobile, token, onDone]);

  return { mobile, setMobile, agreed, setAgreed, error, busy, save, skip };
};

export default useAddMobileStep;
